<template>
  <div class="orderbill">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="销售订单" name="1">
                <div class="search">
                    <el-input v-model="ordernum" placeholder="订单号"></el-input>
                    <el-input v-model="username" placeholder="客户姓名"></el-input>
                    <el-input v-model="carnum" placeholder="车架号"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="shopName"
                            label="4S店名称"
                            width="200">
                        </el-table-column>
                        <el-table-column
                            prop="districtName"
                            label="区域"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            prop="payType"
                            label="结算方式"
                            width="130">
                            <template slot-scope="scope">
                                {{scope.row.payType == 1?'月结':scope.row.payType == 2?'预付款':'扫码付款'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100"
                            prop="productName"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            width="100"
                            prop="code"
                            label="订单号">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            width="90"
                            label="车主姓名">
                        </el-table-column>
                         <el-table-column
                            prop="vin"
                            width="130"
                            label="车架号">
                        </el-table-column>
                        <el-table-column
                            prop="carModelOne"
                            width="100"
                            label="汽车车型">
                            <template slot-scope="scope">
                                {{scope.row.carModelOne + scope.row.carModelTwo}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="saleMoney"
                            label="销售金额">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="paymentDate"
                            label="销售日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="作废订单" name="2">
                <div class="search">
                    <el-input v-model="ordernum" placeholder="订单号"></el-input>
                    <el-input v-model="username" placeholder="客户姓名"></el-input>
                    <el-input v-model="carnum" placeholder="车架号"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData1"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="shopName"
                            label="4S店名称"
                            width="200">
                        </el-table-column>
                        <el-table-column
                            prop="districtName"
                            label="区域"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            prop="payType"
                            label="结算方式"
                            width="130">
                            <template slot-scope="scope">
                                {{scope.row.payType == 1?'月结':scope.row.payType == 2?'预付款':'扫码付款'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100"
                            prop="productName"
                            label="产品名称">
                        </el-table-column>
                        <el-table-column
                            width="100"
                            prop="code"
                            label="订单号">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            width="90"
                            label="车主姓名">
                        </el-table-column>
                         <el-table-column
                            prop="vin"
                            width="130"
                            label="车架号">
                        </el-table-column>
                        <el-table-column
                            prop="carModelOne"
                            width="100"
                            label="汽车车型">
                            <template slot-scope="scope">
                                {{scope.row.carModelOne + scope.row.carModelTwo}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="saleMoney"
                            label="销售金额">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="paymentDate"
                            label="销售日期">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="refundMoney"
                            label="退款金额">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="revokeAuditDate"
                            label="作废日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <div class="page">
                <el-pagination
                    :background="true"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
      </el-tabs>
  </div>
</template>

<script>
import {saleDetailStatistics} from '../axios/api'
export default {
    data(){
        return{
            activeName:'1',
            carnum:'',
            username:'',
            ordernum:'',
            tabid:'1',
            tableData:[],
            tableData1:[],
            page:1,
            total:0,
            states:0
        }
    },
    created(){
        console.log(this.$route.params)
        if(this.$route.params.row){
             window.localStorage.setItem('months',this.$route.params.row.month)
              window.localStorage.setItem('ids',this.$route.params.row.shopId)
              window.localStorage.setItem('payType',this.$route.params.row.payType)
        }
        this.getdata()
    },
    methods:{
        handleClick(tab, event) {
            this.ordernum = ''
            this.username = ''
            this.carnum = ''
            console.log(tab, event);
            this.tabid = tab.name
            this.getdata()
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.states == 0){
                this.getdata()
            }else if(this.states == 1){
                this.search1()
            }
        },
        look(row){
            console.log(row)
            this.$router.push({
                name:'订单详情',
                params:{
                   code:row.code,
                   id:row.saleId
                }
            })
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await saleDetailStatistics({
                saleMonth:window.localStorage.getItem('months'),
                billType:1,
                detailType:this.tabid,
                shopId:window.localStorage.getItem('ids'),
                payType:window.localStorage.getItem('payType'),
                current:this.page,
                limit:10
            })
            console.log(dt)
            if(dt.code == 200){
                if(this.tabid == 1){
                    this.tableData = dt.data.page.records
                }else{
                    this.tableData1 = dt.data.page.records
                }
                
                this.total = dt.data.page.total
            }
        },
        async search(){
             this.states = 1
            var {data:dt} = await saleDetailStatistics({
                saleMonth:this.$route.params.row.month,
                billType:1,
                detailType:this.tabid,
                shopId:this.$route.params.row.shopId,
                payType:this.$route.params.row.payType,
                current:1,
                limit:10,
                code:this.ordernum,
                name:this.username,
                vin:this.carnum
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                if(this.tabid == 1){
                    this.tableData = dt.data.page.records
                }else{
                    this.tableData1 = dt.data.page.records
                }
                
                this.total = dt.data.page.total
            }
        },
        async search1(){
             this.states = 1
            var {data:dt} = await saleDetailStatistics({
                saleMonth:this.$route.params.row.month,
                billType:1,
                detailType:this.tabid,
                shopId:this.$route.params.row.shopId,
                payType:this.$route.params.row.payType,
                current:this.page,
                limit:10,
                code:this.ordernum,
                name:this.username,
                vin:this.carnum
            })
            console.log(dt)
            if(dt.code == 200){
                if(this.tabid == 1){
                    this.tableData = dt.data.page.records
                }else{
                    this.tableData1 = dt.data.page.records
                }
                
                this.total = dt.data.page.total
            }
        }
    }
}

</script>
<style lang="less">
.orderbill{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link .el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
}
</style>